import { AxiosResponse } from "axios"
import { axiosInstance, MessageResponse } from "./common"

interface ContentWithMetadata {
    value: string;
    ai_generated: string;
    user_updated: string;
}

export interface CaseObservations {
    case_id: string;
    modus_operandi: ContentWithMetadata | null;
    incident_type: ContentWithMetadata | null;
    fraud_category: ContentWithMetadata | null;
    lapses_identified: ContentWithMetadata | null;
    lapse_root_cause: ContentWithMetadata | null;
    additional_observations: ContentWithMetadata | null;
    data_used?: Record<string, any> | null;
}

export interface GenerateObservationsRequest {
    case_id: string;
}
export interface GetObservationsParams extends GenerateObservationsRequest {}

export interface UpdateObservationsRequest {
    modus_operandi?: ContentWithMetadata | null;
    incident_type?: ContentWithMetadata | null;
    fraud_category?: ContentWithMetadata | null;
    lapses_identified?: ContentWithMetadata | null;
    lapse_root_cause?: ContentWithMetadata | null;
    additional_observations?: ContentWithMetadata | null;
  }


const ObservationsAPI = {
    create: async (request: GenerateObservationsRequest) => {
        const response: AxiosResponse<CaseObservations> = await axiosInstance.post('v1/observations/generate', request);
        console.log("Observations API Response is:",response.data)
        return response.data;
    },

    get: async (params: GetObservationsParams) => {
        const response: AxiosResponse<CaseObservations> = await axiosInstance.get('v1/observations',{
            params: params
        });
        console.log("Observations API Response is:",response.data)
        return response.data;
    },
    
    update: async (caseId: string, request: UpdateObservationsRequest) => {
        const response: AxiosResponse<MessageResponse> = await axiosInstance.patch(`/v1/cases/${caseId}/observations`, request);
        return response.data;
    }
}

export default ObservationsAPI;